import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {  BarChartOutlined, CodeOutlined, CommentOutlined, FileOutlined, FileTextOutlined, FundOutlined, LineChartOutlined, NotificationOutlined, SearchOutlined, SettingOutlined, ShareAltOutlined, ShopOutlined, StarOutlined, UserAddOutlined, UserOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { useAuth } from '../../../store/AuthContext/AuthContext';
import "../../pages/common/header/MainHeader.scss"
import { useIsAuthorized } from '../../pages/common/roles/Roles';

const MainMenu = () => {
	
	const { profile } = useAuth();
	const { t } = useTranslation();
	const location = useLocation();
	const isAuthorized = useIsAuthorized();
	const current = location.pathname.split('/')[1];
	//console.log('PATH >>>' + current);
	
	return (
				
		<Menu  disabledOverflow={true} style={{ background: 'transparent' }} mode='horizontal' 
			selectedKeys={[current]}>		
		{
			 [		
				isAuthorized(['ROLE_ADMIN', 'ROLE_CLIENT', 'ROLE_AGENT', 'ROLE_GUEST_VIEW', '']) && <Menu.Item key={'negocios'} className="custom-menu-item1">
					<Link to={'/negocios/locales'}>
						<ShopOutlined style={{fontSize:'17px'}}/>Negocios
					</Link>
				</Menu.Item>,
				isAuthorized(['ROLE_ADMIN', 'ROLE_CLIENT', 'ROLE_AGENT', 'ROLE_GUEST_VIEW']) && <Menu.Item key={'clientes'}>
					<Link to={'/clientes/locationsreviews'}>
						<StarOutlined style={{fontSize:'17px'}}/>{t('menu.reviews')}
					</Link>
				</Menu.Item>,
				isAuthorized(['ROLE_ADMIN', 'ROLE_CLIENT', 'ROLE_AGENT', 'ROLE_GUEST_VIEW']) && <Menu.Item key={'contenidos'}>
				<Link to={'/contenidos/locales'} >
					<NotificationOutlined style={{fontSize:'17px'}}/>Publicaciones
				</Link>
				</Menu.Item>,					
				isAuthorized(['ROLE_ADMIN', 'ROLE_CLIENT', 'ROLE_AGENT', 'ROLE_GUEST_VIEW']) && <Menu.Item key={'informes'}>
					<Link to={'/informes/mail'}>
						<SearchOutlined style={{fontSize:'17px'}}/>Insights
					</Link>
				</Menu.Item>,
				isAuthorized(['ROLE_ADMIN', 'ROLE_CLIENT', 'ROLE_AGENT', 'ROLE_GUEST_VIEW']) && <Menu.Item key={'configurar'}>
					<Link to={'/configurar/plan'}>
						<SettingOutlined style={{fontSize:'17px'}}/>
					</Link>
				</Menu.Item>,
				// ADMIN
				profile.roles.includes('ROLE_ADMIN') && <Menu.Item key={'admin'}>
					<Link to={'/admin/usuarios'}>
						<SettingOutlined style={{fontSize:'17px', color:'lavender'}}/>
					</Link>
				</Menu.Item>,
				profile.roles.includes('ROLE_ADMIN') && <Menu.Item key={'tech'}>
					<Link to={'/tech/services'}>
						<CodeOutlined style={{fontSize:'17px', color:'lavender'}}/>
					</Link>
				</Menu.Item>				
			]
		}
		</Menu>			
	)
};

export default MainMenu;